import {hy_safetyProjectMonthEval} from "./hy_safetyProjectMonthEval.js"
export const hy_safetyProjectMonthEvalDetail = {
    "id": "",
    "monthevalid": "",
    safetyProjectMonthEval:hy_safetyProjectMonthEval,
    "conunitid": "",
    "proid": "",
    "curyear":0,
    "curmonth": 0,
    "itemid": "",
    "itemname": "",
    "archArea":0,
    "structType": "",
    "hzgaint": 0,
    "xmgaint1":"",
    "xmgaint2":"",
    "xmgaint3":"",
    "xmgaint4":"",
    "xmgaint5": "",
    "xmgaint6": "",
    "xmgaint7":"",
    "xmgaint8":"",
    "xmgaint9":"",
    "xmgaint10":"",
    "datasource": "",
    "delFlag": 0,
    "progress": "",
    "progressmx": "",
    "synTimestamp": ""
}


// WEBPACK FOOTER //
// ./src/entity/hy_safetyProjectMonthEvalDetail.js